import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';
import {Typography} from '@material-ui/core';
import {Droppable, Draggable} from 'react-beautiful-dnd';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: '15px 20px',
    margin: 0,
  },
  chip: {
    // margin: theme.spacing(0.9),
    'margin': '4px',
    'color': '#000',
    'fontFamily': 'articulat-cf, sans-serif !important',
    'fontWeight': '500',
    '& .MuiChip-label': {
      fontSize: '11px',
      fontWeight: '500px',
      margin: '8px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      // font-size: '13px',
      paddingLeft: '12px',
      paddingRight: '12px',
      textOverflow: 'ellipsis',
    },
  },
  headings: {
    width: '100%',
    color: '#000',
    fontSize: '14px !important',
    fontWeight: '600 !important',
    fontFamily: 'articulat-cf, sans-serif !important',
  },
}));

const ColoumnChips = ({chipData}) => {
  const classes = useStyles();

  // const handleDelete = (chipToDelete) => () => {
  //   setChipData((chips) =>
  //     chips.filter((chip) => chip.key !== chipToDelete.key)
  //   );
  // };

  return (
    <Paper component="div" className={classes.root}>
      <Typography className={`${classes.headings}`} component="h2">
        Selected Widgets
      </Typography>
      {chipData.columnOrder
        .filter((data) => data === 'column-2')
        .map((columnId, i) => {
          const column = chipData.columns[columnId];
          const tasks = column.taskIds.map((taskId) => chipData.tasks[taskId]);
          return (
            <Droppable droppableId={column.id} key={i}>
              {(provided) => (
                <div className="row p-2" ref={provided.innerRef} {...provided.droppableProps}>
                  {tasks.map((task, index) => (
                    <Draggable key={task.id} draggableId={task.id} index={index}>
                      {(provided) => (
                        <div
                          key={task.id}
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <Chip label={task.content} className={classes.chip} />
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          );
        })}
      {/* {chipData.map((data) => {
        let icon;


        return (
          <li key={data.key}>
            <Chip icon={icon} label={data.label} className={classes.chip} />
          </li>
        );
      })} */}
    </Paper>
  );
};

export default ColoumnChips;
